import React, { useState } from 'react';
import { MdLogin, MdArrowBack } from 'react-icons/md';
import { useAuthContext } from '@/features/auth/providers/AuthProvider';
import { forgotPassword } from '../api/auth.api';
import { toast } from 'react-hot-toast';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

export const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [isResetMode, setIsResetMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuthContext();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isResetMode) {
      setIsLoading(true);
      try {
        await forgotPassword({ email: username });
        toast.success(
          'Un lien de réinitialisation a été envoyé à votre adresse email',
          {
            duration: 5000,
          }
        );
        setIsResetMode(false);
      } catch (error) {
        toast.error("Erreur lors de l'envoi du lien de réinitialisation");
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(true);
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const success = await login({ username, password });
        if (success) {
          setError(false);
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
        toast.error('Erreur lors de la connexion');
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="flex h-full min-h-[inherit] w-full flex-col items-center justify-center gap-2 rounded-md px-4 py-2 text-center opacity-80">
      <section className="w-full max-w-[450px] px-4">
        <div className="w-full rounded-lg bg-white shadow dark:bg-neutralBG-dark">
          <div className="space-y-6 p-6">
            <div>
              <h1 className="text-center text-2xl font-normal text-neutralText dark:text-neutralText-dark">
                doc<span className="font-semibold">Teller</span>
              </h1>
            </div>
            <form
              className="space-y-6"
              action="#"
              name="login"
              id="login"
              onSubmit={handleSubmit}
            >
              <Input
                type={isResetMode ? 'email' : 'text'}
                label={
                  isResetMode
                    ? 'Votre adresse email'
                    : "Votre nom d'utilisateur"
                }
                value={username}
                onChange={setUsername}
                placeholder={
                  isResetMode ? 'email@exemple.com' : "nom d'utilisateur"
                }
                error={error}
                required={true}
                autoComplete="off"
                id="username"
                name="username"
              />
              {!isResetMode && (
                <Input
                  type="password"
                  label="Votre mot de passe"
                  value={password}
                  onChange={setPassword}
                  placeholder="••••••••"
                  error={error}
                  required={true}
                  autoComplete="off"
                  id="password"
                  name="password"
                />
              )}
              <div className="flex flex-col gap-2">
                <Button
                  type="submit"
                  disabled={isLoading}
                  startIcon={<MdLogin className="text-xl" />}
                  className="flex w-full items-center justify-center rounded-lg bg-primary px-5 py-3 text-center text-sm font-medium text-neutralBG shadow-sm transition-all duration-100 hover:bg-primaryHover disabled:opacity-50 dark:bg-primary-dark dark:text-neutralBG dark:hover:bg-primaryHover-dark"
                  isLoading={isLoading}
                >
                  {isResetMode
                    ? isLoading
                      ? 'Envoi en cours...'
                      : 'Envoyer le lien'
                    : isLoading
                      ? 'Connexion en cours...'
                      : 'Se connecter'}
                </Button>
                {isResetMode ? (
                  <Button
                    variant="text"
                    onClick={() => setIsResetMode(false)}
                    startIcon={<MdArrowBack className="text-xl" />}
                  >
                    Retour
                  </Button>
                ) : (
                  <Button variant="text" onClick={() => setIsResetMode(true)}>
                    Mot de passe oublié ?
                  </Button>
                )}
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};
